import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Pillars from "@/components/Pillars";
import Donate from "@/components/Donate";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Header />
      <Hero />
      <Marquee />
      <Manifesto />
      <Pillars />
      <Donate />
      <Footer />
    </main>
  );
}
